module.exports = __webpack_public_path__ + "img/caymanislands.a5712729.svg";